import { React, Fragment, memo, useState, useEffect } from 'react'
import {
  BodyText,
  HeadingText,
  Button,
  Container,
  Row,
  Col,
  Link,
  CaptionText,
} from '@paypalcorp/pp-react'
import {
  PRIVACY_HOME,
  PRIVACY_MERCHANT_HOME_FROM_DAR,
  PYPL_CONTACTUS_URL,
} from '../../../constants/constants'
import { Message } from '@paypalcorp/worldready-react'
import serverData from '../../../utils/server-data'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import {
  fptiCustomSetup,
  fptiCustomClick,
  isFeatureEnabled,
} from '../../../utils'
const { accountType = '' } = serverData

const enabledForSLAtime = isFeatureEnabled('enabledSLAtime')
const slaTimeDays = 3
const slaTimeHours = 24
const getReturnUrl = () => {
  let returnurl = PRIVACY_HOME
  if (accountType === 'BUSINESS') {
    returnurl = PRIVACY_MERCHANT_HOME_FROM_DAR
  }
  return returnurl
}

const DARSuccess = memo(() => {
  const { userEmailid = '', locality: { locale = '' } = {} } = serverData
  const darFpti = DATAPRIVACY_FPTI.DAR
  const [impressionDone, setImpressionDone] = useState(false)
  const [noofDays, setNoofDays] = useState('30')
  const DARCOMPLETIONDAYS = {
    'en-AR': '10',
    'es-AR': '10',
    'en-AU': '10',
    'pt-BR': '15',
    'en-BR': '15',
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(darFpti.SUCCESS_IMPRESSION)
    }
    setNoofDays(DARCOMPLETIONDAYS[locale] || '30')
  }, [])
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="requestForm-response-msg-header">
          <img
            className="requestForm-response-msg-image"
            alt="success"
            aria-hidden="true"
            src={`https://${serverData.cdnHostName}/paypal-ui/illustrations/svg/activity.svg`}
          />
        </div>

        <Row className="dataPrivacy-row">
          <Col>
            <div className="text-center">
              <HeadingText id="darSuccessHeader" size="sm">
                <Message id="dar.section.success.heading" />
              </HeadingText>
            </div>
          </Col>
        </Row>
        <Row className="dataPrivacy-row">
          <Col>
            <BodyText className="text-center">
              {enabledForSLAtime ? (
                <Message
                  id="dar.section.success.bodycontentdays"
                  emailId={userEmailid}
                  noofDays={noofDays}
                  slaTime={slaTimeDays}
                />
              ) : (
                <Message
                  id="dar.section.success.bodycontenthours"
                  emailId={userEmailid}
                  noofDays={noofDays}
                  slaTime={slaTimeHours}
                />
              )}
            </BodyText>
          </Col>
        </Row>
        <Row className="dataPrivacy-row">
          <Col>
            <div className="requestForm-header-info">
              <BodyText className="text-center">
                <Message id="dar.section.success.tilecontent" />
              </BodyText>
            </div>
          </Col>
        </Row>

        <Row className="requestForm-row">
          <Col className="d_flex justifycenter requestForm-row">
            <Button
              name="closeBtn"
              id="darSuccessDoneBtn"
              onClick={() => {
                fptiCustomClick(darFpti.SUCCESS_DONE)
                location.href = getReturnUrl()
              }}
            >
              <Message id="dar.section.success.buttonlabel" />
            </Button>
          </Col>
        </Row>

        <Row className="margin_b_2 requestForm-row">
          <Col className="d_flex flex_row flex_gap_small justifycenter">
            <CaptionText className="caption-text">
              <Message id="dar.edpbdar.anyquestions" />
            </CaptionText>
            <Link href={PYPL_CONTACTUS_URL} size="sm">
              <Message id="dar.edpbdar.contactus" />
            </Link>
          </Col>
        </Row>
      </Container>
    </Fragment>
  )
})

DARSuccess.displayName = 'DARSuccess'

export default DARSuccess
